import React from 'react';
import moment from 'moment';

import Label from '../components/Label';

const getDueDateLabel = (date: any) => {
  if (!date) {
    return (
      <Label>
        No due date
      </Label>
    );
  }

  if (moment(date).isBefore(moment(), 'day')) {
    return (
      <Label color="error">
        {`Due ${moment(date).fromNow()}`}
      </Label>
    );
  }

  if (moment(date).isSame(moment(), 'day')) {
    return (
      <Label color="warning">
        Due today
      </Label>
    );
  }

  return (
    <Label color="warning">
      {`Due ${moment(date).fromNow()}`}
    </Label>
  );
};

export default getDueDateLabel;
